import React, { useEffect } from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import employeeLoginService, {
  saveUserService,
} from "../../services/AuthService";
import { employeerAuthService } from "../../services/AuthService";
import uiConfig from "../../helpers/Firebase";

import { Card } from "reactstrap";
import { isNullOrEmpty } from "../../config/ENV";

const Firebaselogin = () => {
  const Login = () => {
    employeerAuthService().then((response) => {
      if (response.data !== undefined && response.data !== "") {
        if (response.data.failure_code === "ACCOUNT_DOESNOT_EXIST") {
          if (!isNullOrEmpty(window.sessionStorage.getItem("empcode"))) {
            memberSignUp();
          } else {
            window.localStorage.setItem("account", "NewUser");
            window.location.href = "/";
          }
        }

        if (response.status === 200) {
          const loginResposne = response.data;
          window.localStorage.setItem("user", loginResposne.id);

          if (loginResposne.email !== null) {
            window.localStorage.setItem("email", loginResposne.email);
          }

          if (loginResposne.firstName !== null) {
            window.localStorage.setItem("name", loginResposne.firstName);
          }
          if (loginResposne.lastName !== null) {
            window.localStorage.setItem("lastName", loginResposne.lastName);
          }

          if (loginResposne.contactNumber !== null) {
            window.localStorage.setItem(
              "phoneNumber",
              loginResposne.phoneNumber
            );
          }
          window.localStorage.setItem(
            "employerName",
            loginResposne.employerName
          );
          if (loginResposne.role !== null) {
            window.localStorage.setItem("userRole", loginResposne.role);
          }
          window.location.href = "/";
        }
      }
    });
  };

  const memberSignUp = (user) => {
    saveUserService().then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            saveUserDetails(user);
            Login();
          }
        }
      } catch (err) {}
    });
  };

  useEffect(() => {   
    if (
      window.localStorage.getItem("user") == null ||
      window.localStorage.getItem("user") == ""
    ) {
      const unregisterAuthObserver = firebase
        .auth()
        .onAuthStateChanged((user) => {
          if (user) {
            firebase
              .auth()
              .currentUser.getIdToken(/* forceRefresh */ true)
              .then(function (idToken) {
                window.localStorage.setItem("authToken", idToken);
                if (!isNullOrEmpty(window.sessionStorage.getItem("empcode"))) {
                  memberSignUp(user);
                } else {
                  saveUserDetails(user);
                  Login();
                }
              });
          }
        });
      return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
    }
  }, []);

  const saveUserDetails = (user) => {
    if (user.email !== null) {
      window.localStorage.setItem("email", user.email);
    } else {
      window.localStorage.setItem("email", "");
    }

    if (user.displayName !== null) {
      const fullName = user.displayName.split(" ");
      window.localStorage.setItem("name", fullName[0]);
      window.localStorage.setItem("lastName", fullName[1]);
    } else {
      window.localStorage.setItem("name", "");
      window.localStorage.setItem("lastName", "");
    }

    if (user.phoneNumber !== null) {
      window.localStorage.setItem("phoneNumber", user.phoneNumber);
    } else {
      window.localStorage.setItem("phoneNumber", "");
    }

    try {
      if (user != null) {
        let stsTokenManager = user.toJSON().stsTokenManager;
        if (stsTokenManager != null) {
          let expirationTime = stsTokenManager.expirationTime;
          if (expirationTime != null) {
            window.localStorage.setItem(
              "authTokenExpirationTime",
              expirationTime
            );
          }
        }
      }
    } catch (err) {}
  };

  return (
    <>
      <Card className="t-firebase-margin-top">
        <div>
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
        </div>
      </Card>
    </>
  );
};

export default Firebaselogin;
